import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  uploadMakeRequest: ["withdrawal_id", "withdrawal_file"],
  uploadMakeSuccess: ["Status"],
  uploadMakeFailure: null,
});

export const UploadMakeTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  withdrawal_id: null,
  fetching: null,
  error: null,
  success: null,
  Status: null,
  withdrawal_file: null,
});

export const UploadMakeSelectors = {
  getData: (state: any) => state.uploadMake.data,
  isFetching: (state: any) => state.uploadMake.fetching,
  isSuccess: (state: any) => state.uploadMake.success,
  hasError: (state: any) => state.uploadMake.error,
};

export const request = (state: any, { withdrawal_id, withdrawal_file }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    withdrawal_id: withdrawal_id,
    withdrawal_file: withdrawal_file,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { Status } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    Status,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    goal: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.UPLOAD_MAKE_REQUEST]: request,
  [Types.UPLOAD_MAKE_SUCCESS]: success,
  [Types.UPLOAD_MAKE_FAILURE]: failure,
});
